import React from 'react'

const MaintenancePage: React.FC = () => {
  return (
    <div className="bg-surface flex flex-1 items-center justify-center overflow-hidden box-border h-screen w-full px-20">
      <div className="flex flex-col w-full justify-center items-center">
        <div className="mb-4 text-[2rem] mt-0">System Maintenance</div>
        <div className="mb-4 flex mt-5">
          We are currently performing scheduled maintenance to improve our services. Please check back soon.
        </div>
      </div>
    </div>
  )
}

export default MaintenancePage
